const list = {
  components() {
    return [
      // ===========[ 날짜 관련 ]==========
      {
        component: "search-year",
        label: "평가연도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          gridTemplateColumns: "114px 178px",
          xlWidthFull: true,
        },
      },
      {
        component: "search-start-end",
        label: "평가일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
          gridTemplateColumns: "114px 1fr",
        },
      },
      { component: "empty-space" },
      {
        component: "search-check-group",
        label: "중요위험",
        value: "importantRisk",
        query: { ck_l: "checkList" },
        options: {
          list: [
            { text: "Y", value: "Y" },
            { text: "N", value: "N" },
          ],
          selectMaxCount: 2,
          default: [],
          gridTemplateColumns: "114px 178px",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: {
          hiddenList: ["중요위험", "평가일", "산업재해 발생 현황", "위험성평가(개선전)"],
          gridTemplateColumns: "114px 1fr",
        },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({ key: "header.year", operator: "=", value: search.year });
    }

    //  검색일
    if (search.date) {
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.위험성평가정보.평가일자", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 중요위험
    if (search.importantRisk && search.importantRisk.length > 0) {
      conditions.push({ key: "body.위험성평가표.중요위험", operator: "IN", value: search.importantRisk });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }

    // 대분류 (815/page 검색에서 사용됨)
    if (search.대분류) {
      conditions.push({ key: "body.공정분류.raw.대분류", operator: "LIKE", value: `%${search.대분류}%` });
    }

    // 중분류 (815/page 검색에서 사용됨)
    if (search.중분류) {
      conditions.push({ key: "body.공정분류.raw.중분류", operator: "LIKE", value: `%${search.중분류}%` });
    }

    // 소분류 (815/page 검색에서 사용됨)
    if (search.소분류) {
      conditions.push({ key: "body.공정분류.raw.소분류", operator: "LIKE", value: `%${search.소분류}%` });
    }

    return conditions;
  },

  /**
   * 목록을 불러온 이후 실제 데이터 값을 list 변수에 저장하기 전에 실행되는 함수 ( this.listAll = response.data 하기 전 )
   * 목록에 표기되는 데이터의 postId 를 배열로 만들어서 944를 조회한다.
   * @param response : 목록데이터
   * @param options : 목록데이터를불러올때사용한옵션
   * @returns {Promise<*>}
   */
  prefixFunc: async (vue, response, options) => {
    const postIds = response.data.map((data) => {
      const body = JSON.parse(data.post_content).body;
      return body.connect823Id;
    });

    if (postIds && postIds.length > 0) {
      const conditions = [];
      conditions.push({ key: "body.connect823Id", operator: "IN", value: postIds });

      //  944 호출
      const res944 = await vue.$store.dispatch("approval/LOAD_POST_ALL", { projectId: options.projectId, boardSlug: `board-944`, page: 1, perPage: options.perPage, orderTarget: "created_at", orderDirection: "desc", conditions });
      const list944 = res944 && res944.data && res944.data.length > 0 ? res944.data : [];

      // 944에 데이터가 존재하는지 찾아 넣는다.
      const jsonConnect = {};
      for (let i = 0; i < list944.length; i++) {
        const body944 = JSON.parse(list944[i].post_content).body;
        const postId823 = body944.connect823Id;
        const postId = list944[i].post_id;
        jsonConnect[postId823] = postId;
      }

      console.log(jsonConnect);

      // response.data 에 otherPosts 추가
      response.data = response.data.map((data) => {
        const postId823 = JSON.parse(data.post_content).body.connect823Id;
        return {
          ...data,
          postId944: jsonConnect[postId823] || null,
        };
      });
    }

    return response;
  },

  getHead: () => {
    return [
      {
        name: "구분1",
        key: "body.공정분류.구분",
      },
      {
        name: "구분2",
        key: "body.위험성평가구분",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "팀명",
        key: "body.위험성평가정보.팀",
      },
      {
        name: "대분류",
        key: "body.공정분류.raw.대분류",
      },
      {
        name: "중분류",
        key: "body.공정분류.raw.중분류",
      },
      {
        name: "소분류",
        key: "body.공정분류.raw.소분류",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "중요위험",
        key: "body.위험성평가표.중요위험",
      },
      {
        name: "평가일",
        key: "body.위험성평가정보.평가일자",
      },
      {
        name: "아차사고",
        key: "body.공정분류.아차사고",
      },
      {
        name: "산업재해 발생 현황",
        key: "",
      },
      {
        name: "위험성평가(개선전)",
        key: "",
      },
    ];
  },

  getCol: (index, value, func) => {
    try {
      const content = func.getContent(value);
      console.log();
      switch (index) {
        case 0:
          return content.공정분류.구분; // 구분1
        case 1:
          return content.위험성평가구분; // 구분2
        case 2:
          return content.stdInfo.field_name; // 사업장명
        case 3:
          return content.위험성평가정보.팀; // 팀명
        case 4:
          return content.공정분류.raw.대분류; // 대분류
        case 5:
          return content.공정분류.raw.중분류; // 중분류
        case 6:
          return content.공정분류.raw.소분류; // 소분류
        case 7:
          return content.stdInfo.writer_name; // 작성자
        case 8:
          return content.위험성평가표.중요위험; // 중요위험
        case 9:
          return content.위험성평가정보.평가일자; // 평가일
        case 10:
          return content.공정분류.아차사고; // 아차사고
        case 11: // 산업재해 발생 현황
          return {
            type: "post-link",
            projectId: value.project_id,
            boardId: 823,
            postId: content.connect823Id,
          };
        case 12: // 위험성평가(개선전)
          if (value.postId944)
            return {
              type: "post-link",
              projectId: value.project_id,
              boardId: 944,
              postId: value.postId944,
            };
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
};

export default list;
